import { TaskListView } from "../types";
import { produceTasksPageStorageHook } from "./storageHookProducers";

/**
 * Storage for selected view (tab) in the Tasks List page.
 */
export const useTaskListViewStorage = produceTasksPageStorageHook<TaskListView>(
  {
    storageName: "VIEW",
    storageType: "local",
    getInitialValue: (isDemo) => ({ type: isDemo ? "table" : "kanban" }),
  }
);
